import { motion } from "framer-motion";
import SectionHeading from "@/components/common/SectionHeading";
import Icon from "@/components/common/Icon";
import { easeOut } from "@/components/common/Reveal";
import { WHY } from "@/data/site";

export default function WhyChoose() {
  return (
    <section className="bg-slate-50/60 py-24 lg:py-32" data-testid="why-choose">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHeading
          eyebrow="Pourquoi choisir Educaser"
          title="Une formation d'excellence, un accompagnement de bout en bout"
          intro="De l'inscription à l'obtention de votre qualification, nous mettons tout en œuvre pour votre réussite."
        />

        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {WHY.map((w, i) => (
            <motion.div
              key={w.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, ease: easeOut, delay: (i % 3) * 0.08 }}
              className={`group rounded-2xl border border-slate-200 bg-white p-8 transition-all duration-300 hover:-translate-y-1 hover:border-transparent hover:shadow-[0_16px_48px_rgba(0,35,102,0.12)] ${
                i === 0 ? "sm:col-span-2 lg:col-span-1" : ""
              }`}
              data-testid={`why-card-${i}`}
            >
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-blue/5 text-brand-blue transition-colors group-hover:bg-brand-red group-hover:text-white">
                <Icon name={w.icon} className="h-6 w-6" />
              </div>
              <h3 className="mt-5 font-display text-lg font-bold text-brand-blue">{w.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-500">{w.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
